import {
  useKomboIntegrationFindOneQuery,
  useKomboSetAssessmentPackagesMutation,
} from 'generated/graphql';
import {
  Button,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import styles from './IntegrationsTab.module.scss';

type AssessmentPackagesCardProps = {
  companyId: number;
};

export function AssessmentPackagesCard({
  companyId,
}: AssessmentPackagesCardProps) {
  const { handleMsgType } = useNotification();

  const { data } = useKomboIntegrationFindOneQuery({
    variables: { companyId },
  });
  const integration = data?.komboIntegrationsFindOne;

  const [setPackages, { loading: isSettingPackages }] =
    useKomboSetAssessmentPackagesMutation({
      variables: { companyId },
      onCompleted: () => {
        handleMsgType({
          type: TNotification.success,
          message: 'Assessment packages sync started',
        });
      },
      onError: error => {
        handleMsgType({
          type: TNotification.error,
          message: error.message,
        });
      },
    });

  // Package registration only applies to integrations with an assessment
  // connection — hide the card entirely otherwise.
  if (!integration?.enabled || !integration.assessmentIntegrationId) {
    return null;
  }

  return (
    <div className={styles.viewContainer}>
      <div className={styles.header}>
        <h3 className={styles.title}>Assessment packages</h3>
        <Button
          variant="secondary"
          size="medium"
          disabled={isSettingPackages}
          data-testid="integrations__set-packages-button"
          onClick={() => setPackages()}
        >
          Set packages
        </Button>
      </div>
      <div className={styles.content}>
        <p className={styles.description}>
          Re-push the current list of assessment packages (one per assessment
          stage of each published, unlinked role) to the company&apos;s ATS via
          Kombo. Fire-and-forget: the sync is dispatched in the background and
          safe to repeat.
        </p>
      </div>
    </div>
  );
}
